var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownLight = function SvgArrowDownLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58665 1.19329L3.99999 3.77996L1.41332 1.19329C1.15332 0.933291 0.73332 0.933291 0.47332 1.19329C0.21332 1.45329 0.21332 1.87329 0.47332 2.13329L3.53332 5.19329C3.79332 5.45329 4.21332 5.45329 4.47332 5.19329L7.53332 2.13329C7.79332 1.87329 7.79332 1.45329 7.53332 1.19329C7.27332 0.939958 6.84665 0.933291 6.58665 1.19329Z"
  })));
};
export default SvgArrowDownLight;